import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class DocumentFileInfoApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'documentFileInfo'
  }

}